import Base from './base';

const getBridge = async (pageUrl: string) => {
  const Wechat = (await import('./wechat')).default;
  const { IS_WECHAT } = (await import('@/constants'));
  if (!IS_WECHAT) {
    return new Wechat(pageUrl);
  }
  return new Base();
};

export default getBridge;
